import React from "react";
import styles from "./index.module.scss";
import BlessButton from "@/components/layout/button/green-outline-btn";
import Image from "next/image";
import NotFoundImage from "@public/web-content/bless-thinking.png";
import { useBridgeScannerFiltersStore } from "@/features/bridge-scanner/stores/filters.store";
import { useFilterApply } from "@/features/bridge-scanner/hooks/useFilterApply.hook";

type Props = {
  text: string;
  showResetFiltersBtn?: boolean;
};

const NoTransactionFound = ({ text, showResetFiltersBtn = false }: Props) => {
  const { resetQueryParams, clearDateRange } = useBridgeScannerFiltersStore();
  const { resetURLFilterParams } = useFilterApply();

  const handleResetFilters = () => {
    clearDateRange();
    resetQueryParams();
    resetURLFilterParams();
  };

  return (
    <div className={styles.container}>
      <Image
        className={styles.image}
        src={NotFoundImage}
        alt={"Placeholder image for missing transactions"}
      />
      <p className={styles.text}>{text}</p>
      {showResetFiltersBtn && (
        <BlessButton onClick={handleResetFilters}>Reset Filters</BlessButton>
      )}
    </div>
  );
};

export default NoTransactionFound;
